export function transform(data) {
    //console.log("transforming data", Object.keys(data.getAppSearchDetails));

    if(!data) {
        return data;
    }
    if(!data.getAppSearchDetails) {
        return data;
    }
    if(!Array.isArray(data.getAppSearchDetails)) {
        return data;
    }
    
    //add a sequential id to each detail item
    data.getAppSearchDetails.forEach((item, index) => {
        item.id = index + 1;
    
    
    // Check for the clients array and add a sequential id to each client item and convert the createdDate to a Date object
    if (Array.isArray(item.clients)) {
        item.clients.forEach((client, clientIndex) => {
            client.id = clientIndex + 1;
            client.createdDate = new Date(client.createdDate);
        });
    }
});
    

    //console.log("transformed data", data);

    return data;
}
